import Vue from 'vue'

import { Popover, Button, Collapse, CollapseItem, Popup } from 'vant'

Vue.use(Popover).use(Button).use(Collapse).use(CollapseItem).use(Popup)
